
import { Component, Vue } from "vue-property-decorator"
import { Getter, Action } from "vuex-class"

import LightDarkSwitch from "./Account/LightDarkSwitch.vue"
import UserImage from "./UserImage.vue"

import User from "@/types/user"

@Component({
	components: {
		"light-dark": LightDarkSwitch,
		"user-picture": UserImage
	}
})
export default class SlideMenu extends Vue {
	@Getter("getScreenWidth") public screenWidth!: number;
	@Getter("getMe") public me!: User;

	public show: boolean = false;
	public userExpanded: boolean = false;

	@Action("logOut") public logOut!: () => void;

	public open () {
		this.show = true
	}
	public close () {
		this.show = false
	}
}

